import { useUserStatus } from "./useUserStatus";

export function useUser() {
    const { data } = useUserStatus();

    // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
    return data?.user!;
}
